
import { AmbienteInternoPontoFraco } from '../types/negocio/AmbienteInternoPontoFraco';
import api from './api';
import BaseService from './BaseService';

class AmbienteInternoPontoFracoService extends BaseService<AmbienteInternoPontoFraco> {

  constructor() {
    super('ambiente-interno-ponto-fraco', api);
  }  
 
}

export const ambienteInternoPontoFracoService = new AmbienteInternoPontoFracoService();